import { File, Goal, MessageCircleQuestion } from 'lucide-react';
import { Divider } from 'primereact/divider';
import { FC } from 'react';
import StudentLearnOtherResourcesCard from './StudentLearnOtherResourcesCard';

const otherResourcesData = [
  {
    title: '2 skills a week is our goal. But why?',
    subtitle: 'It leads to substantial growth on EOY exams.',
    linkName: ['Learn about this goal'],
    link: ['https://teachtoone.org/two-is-the-magic-number/'],
    icon: <Goal size={18} className="tw-text-stone-800" />,
  },
  {
    title: 'Learning Steps Poster',
    subtitle: 'Hang this up in your classroom so students have a reference.',
    linkName: ['Download poster'],
    link: ['https://drive.google.com/file/d/1jzWUdjYfPtGe70kbmlSFwynO9HTLo1hv/view'],
    icon: <MessageCircleQuestion size={18} className="tw-text-stone-800" />,
  },
  {
    title: 'Note-taking template',
    subtitle: 'Print it once and have students use it to guide their note-taking',
    linkName: ['Download template'],
    link: ['https://drive.google.com/file/d/1E5yfFx3l42g38CD8UmWwUU44DrkaQxRK/view'],
    icon: <File size={18} className="tw-text-stone-800" />,
  },
  {
    title: 'Goal tracker',
    subtitle: 'Printables for students to track their progress',
    linkName: ['Download trackers', 'Worksheet', '50-skill race'],
    link: [
      'https://drive.google.com/file/d/1E5yfFx3l42g38CD8UmWwUU44DrkaQxRK/view',
      'https://drive.google.com/file/d/1EnCmn1bjTgMsROU4gKqA3miDy8qV7tWz/view',
      'https://drive.google.com/file/d/1KpQdQk-n9ylMwbyBvkpr2qgpUAEOcPN-/view?usp=sharing',
    ],
    icon: <File size={18} className="tw-text-stone-800" />,
    overlayPanel: true,
  },
];

const StudentLearnOtherResources: FC = () => {
  return (
    <div className="tw-flex-col tw-flex tw-gap-y-4">
      <Divider />
      <h1 className="tw-text-base tw-font-sora tw-text-neutral-950 tw-font-bold">Other resources</h1>
      <div className="tw-gap-x-6 tw-flex tw-flex-row">
        {otherResourcesData.map(el => {
          return <StudentLearnOtherResourcesCard key={el.title} data={el} />;
        })}
      </div>
    </div>
  );
};

export default StudentLearnOtherResources;
